/* Layout */
import Layout from '@/views/layout/Layout';

export default [
  {
    path: '/distributionManage',
    component: Layout,
    alwaysShow: false,
    meta: {
      title: '自营-分销管理',
      icon: 'component',
    },
    children: [
      {
        path: '/distributionManage/grouping',
        component: () => import('@/myviews/shoppMall/distributionManage/grouping/groupingList.vue'),
        name: 'groupingList',
        meta: {
          alwaysShow: false,
          title: '分组管理',
          roles: ['add', "modify", "viewpage"],
          have: [],
        },
      }, 
      {
        path: '/distributionManage/distributor',
        component: () => import('@/myviews/shoppMall/distributionManage/distributor/distributorList.vue'),
        name: 'distributorList',
        meta: {
          alwaysShow: false,
          title: '分销员管理',
          roles: ['add', "modify", "viewpage"],
          have: [],
        },
      },
      {
        path: '/distributionManage/activities',
        component: () => import('@/myviews/shoppMall/distributionManage/activities/activitiesList.vue'),
        name: 'activitiesList',
        meta: {
          alwaysShow: false,
          title: '分销活动管理',
          roles: ['add', "modify", "viewpage"],
          have: [],
        },
      },
      {
        path: '/distributionManage/commission',
        component: () => import('@/myviews/shoppMall/distributionManage/commission/commissionList.vue'),
        name: 'commissionList',
        meta: {
          alwaysShow: false,
          title: '佣金交易管理',
          roles: ['add', "modify", "viewpage"],
          have: [],
        },
      },
      {
        path: '/distributionManage/withdrawcash',
        component: () => import('@/myviews/shoppMall/distributionManage/withdrawcash/withdrawcashList.vue'),
        name: 'withdrawcashList',
        meta: {
          alwaysShow: false,
          title: '提现管理',
          roles: ['add', "modify", "viewpage"],
          have: [],
        },
      },
    ]
  }
]


// WEBPACK FOOTER //
// ./src/router/shoppMall/distributionManage.js